export default __webpack_public_path__ + "static/media/15t.ea8e83a6.jpg";